import { Reveal } from "../site/Reveal";
import { Check } from "lucide-react";
import { useT } from "@/i18n/useLocale";

export function ValidacionVisual() {
  const t = useT();
  const h = t.facturas.hitl;
  const v = t.facturas.flujo.visual;

  return (
    <section className="border-t border-hairline bg-surface py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl gap-14 px-6 lg:grid-cols-[1fr_1fr] lg:items-center lg:gap-20 lg:px-10">
        <Reveal>
          <div>
            <p className="mb-3 text-xs uppercase tracking-[0.18em] text-ink-soft/70">{h.eyebrow}</p>
            <h2 className="font-display text-4xl leading-[1.05] tracking-tight text-ink sm:text-5xl">
              {h.title}
            </h2>
            <p className="mt-6 max-w-xl text-lg leading-relaxed text-ink-soft">{h.body}</p>
            <ul className="mt-8 space-y-3">
              {h.points.map((p) => (
                <li key={p} className="flex gap-3 text-[15px] leading-relaxed text-ink-soft">
                  <Check className="mt-1 h-4 w-4 shrink-0 text-primary" />
                  <span>{p}</span>
                </li>
              ))}
            </ul>
            <p className="mt-8 border-l-2 border-accent pl-4 text-[15px] font-medium leading-relaxed text-ink">
              {h.note}
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="grid gap-4 rounded-3xl border border-hairline bg-background p-5 shadow-[0_30px_80px_-40px_rgba(30,75,142,0.35)] sm:grid-cols-2 lg:p-6">
            <div className="relative rounded-2xl border border-hairline bg-surface p-4">
              <div className="space-y-2">
                <div className="h-2 w-2/3 rounded-full bg-hairline" />
                <div className="h-2 w-1/2 rounded-full bg-hairline" />
              </div>
              <div className="mt-4 space-y-3">
                <div className="rounded-md border border-primary/50 bg-primary/5 px-2 py-1 text-[11px] font-medium text-primary">
                  {v.fields[0]?.v}
                </div>
                <div className="rounded-md border border-primary/50 bg-primary/5 px-2 py-1 text-[11px] font-medium text-primary">
                  {v.fields[1]?.v}
                </div>
                <div className="rounded-md border border-accent/60 bg-accent/10 px-2 py-1 text-[11px] font-medium text-ink">
                  {v.fields[3]?.v}
                </div>
              </div>
              <div className="mt-4 space-y-1.5">
                {[0, 1, 2, 3].map((i) => (
                  <div key={i} className="h-1.5 w-full rounded-full bg-hairline" />
                ))}
              </div>
            </div>

            <div className="space-y-3">
              {v.fields.map((f) => (
                <div
                  key={f.k}
                  className="flex items-center justify-between gap-2 rounded-xl border border-hairline bg-surface px-3 py-2.5"
                >
                  <span className="text-[11px] uppercase tracking-[0.1em] text-ink-soft">{f.k}</span>
                  <span className="text-xs font-medium text-ink">{f.v}</span>
                </div>
              ))}
              <div className="flex items-center justify-between rounded-xl border border-primary/30 bg-primary/[0.05] px-3 py-2.5">
                <span className="text-[11px] font-medium text-primary">{v.confidence}</span>
                <span className="flex h-6 w-6 items-center justify-center rounded-full bg-primary text-primary-foreground">
                  <Check className="h-3.5 w-3.5" strokeWidth={3} />
                </span>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
